import { deleteClassification } from "@erp/shared/api/generated/wrappers/backdata";
import { patchClassification, } from "@erp/shared/api/generated/wrappers/backdata";
import { postClassification, } from "@erp/shared/api/generated/wrappers/backdata";
import { deleteManufacturer } from "@erp/shared/api/generated/wrappers/backdata";
import { patchManufacturer, } from "@erp/shared/api/generated/wrappers/backdata";
import { postManufacturer, } from "@erp/shared/api/generated/wrappers/backdata";
import { deleteSpot } from "@erp/shared/api/generated/wrappers/backdata";
import { patchSpot, } from "@erp/shared/api/generated/wrappers/backdata";
import { postSpot, } from "@erp/shared/api/generated/wrappers/backdata";
import { useInvalidateQueries } from "@erp/shared/composables/useInvalidateQueries";
import { queries } from "@erp/shared/queries";
import { showAlert } from "@erp/shared/utils/dialog";
import { getErrorMessage } from "@erp/shared/utils/error";
import { useMutation } from "@tanstack/vue-query";
export const useBasicInfoBackdataAction = () => {
    const { invalidateQueries } = useInvalidateQueries();
    const postManufacturerMutation = useMutation({
        mutationFn: async (body) => await postManufacturer(body),
        onError: (err) => {
            showAlert(getErrorMessage(err), "제조사 등록 실패");
        },
        onSuccess: () => {
            showAlert("제조사 등록 완료", "완료");
            invalidateQueries([queries.basicInfo._def]);
        },
    });
    const postClassificationMutation = useMutation({
        mutationFn: async (body) => await postClassification(body),
        onError: (err) => {
            showAlert(getErrorMessage(err), "분류 등록 실패");
        },
        onSuccess: () => {
            showAlert("분류 등록 완료", "완료");
            invalidateQueries([queries.basicInfo._def]);
        },
    });
    const postSpotMutation = useMutation({
        mutationFn: async (body) => await postSpot(body),
        onError: (err) => {
            showAlert(getErrorMessage(err), "장소 등록 실패");
        },
        onSuccess: () => {
            showAlert("장소 등록 완료", "완료");
            invalidateQueries([queries.basicInfo._def]);
        },
    });
    const patchManufacturerMutation = useMutation({
        mutationFn: async ({ id, body, }) => await patchManufacturer(id, body),
        onError: (err) => {
            showAlert(getErrorMessage(err), "제조사 수정 실패");
        },
        onSuccess: () => {
            showAlert("제조사 수정 완료", "완료");
            invalidateQueries([queries.basicInfo._def]);
        },
    });
    const patchClassificationMutation = useMutation({
        mutationFn: async ({ id, body, }) => await patchClassification(id, body),
        onError: (err) => {
            showAlert(getErrorMessage(err), "분류 수정 실패");
        },
        onSuccess: () => {
            showAlert("분류 수정 완료", "완료");
            invalidateQueries([queries.basicInfo._def]);
        },
    });
    const patchSpotMutation = useMutation({
        mutationFn: async ({ id, body }) => await patchSpot(id, body),
        onError: (err) => {
            showAlert(getErrorMessage(err), "장소 수정 실패");
        },
        onSuccess: () => {
            showAlert("장소 수정 완료", "완료");
            invalidateQueries([queries.basicInfo._def]);
        },
    });
    const deleteManufacturerMutation = useMutation({
        mutationFn: async (id) => await deleteManufacturer(id),
        onError: (err) => {
            showAlert(getErrorMessage(err), "제조사 삭제 실패");
        },
        onSuccess: () => {
            showAlert("제조사 삭제 완료", "완료");
            invalidateQueries([queries.basicInfo._def]);
        },
    });
    const deleteClassificationMutation = useMutation({
        mutationFn: async (id) => await deleteClassification(id),
        onError: (err) => {
            showAlert(getErrorMessage(err), "분류 삭제 실패");
        },
        onSuccess: () => {
            showAlert("분류 삭제 완료", "완료");
            invalidateQueries([queries.basicInfo._def]);
        },
    });
    const deleteSpotMutation = useMutation({
        mutationFn: async (id) => await deleteSpot(id),
        onError: (err) => {
            showAlert(getErrorMessage(err), "장소 삭제 실패");
        },
        onSuccess: () => {
            showAlert("장소 삭제 완료", "완료");
            invalidateQueries([queries.basicInfo._def]);
        },
    });
    return {
        postManufacturerMutation,
        postClassificationMutation,
        postSpotMutation,
        patchManufacturerMutation,
        patchClassificationMutation,
        patchSpotMutation,
        deleteManufacturerMutation,
        deleteClassificationMutation,
        deleteSpotMutation,
    };
};
